export default function popupEvent() {
  // Resolve error: $ is not a function
  jQuery.noConflict();
  $('.popup-close').on('click', () => {
    $('.popup-overlay').remove();
  });

  $('.js-checkout').on('click', () => {
    $('.popup-overlay').remove();
    $('#checkout').modal();
  });
}
